import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import ContactList from './pages/ContactList';
import ContactDetails from './pages/ContactDetails';
import Companies from './pages/Companies';
import CompanyDetails from './pages/CompanyDetails';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Settings from './pages/Settings';
import GmailCallback from './pages/GmailCallback';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/UpdatePassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import ProtectedRoute from './components/ProtectedRoute';
import { LandingPage } from './pages/LandingPage';
import EngagementListPage from './pages/engagements/EngagementListPage';
import EngagementDetailsPage from './pages/engagements/EngagementDetailsPage';
import BreakTheIce from './pages/focus/BreakTheIce';
import IceBroken from './pages/focus/IceBroken';
import FollowUps from './pages/focus/FollowUps';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/update-password',
    element: <UpdatePassword />,
  },
  {
    path: '/privacy_policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/auth/gmail/callback',
    element: <ProtectedRoute><GmailCallback /></ProtectedRoute>,
  },
  {
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/focus/break-the-ice',
        element: <BreakTheIce />,
      },
      {
        path: '/focus/ice-broken',
        element: <IceBroken />,
      },
      {
        path: '/focus/follow-ups',
        element: <FollowUps />,
      },
      {
        path: '/contacts',
        element: <ContactList />,
      },
      {
        path: '/contacts/:id',
        element: <ContactDetails />,
      },
      {
        path: '/companies',
        element: <Companies />,
      },
      {
        path: '/companies/:id',
        element: <CompanyDetails />,
      },
      {
        path: '/jobs',
        element: <Jobs />,
      },
      {
        path: '/jobs/:id',
        element: <JobDetail />,
      },
      {
        path: '/settings',
        element: <Settings />,
      },
      {
        path: '/engagements',
        element: <EngagementListPage />,
      },
      {
        path: '/engagements/:id/*',
        element: <EngagementDetailsPage />,
      },
    ],
  },
]);
